import { ORGANIZATION_SEARCH_ETAT_ADMINISTRATIF_ACTIF } from '../constants/organization-search-api.constant';

export const isActiveAdministrativeStatus = (
  etatAdministratif: string | null | undefined,
): boolean =>
  etatAdministratif === ORGANIZATION_SEARCH_ETAT_ADMINISTRATIF_ACTIF;
